module.exports = __webpack_public_path__ + "static/media/PDF_44.63528ede.pdf";